import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_REVIEW_START,
} from '../../actions/types'

import {
  updateReviewSuccess,
  updateReviewFailure,
} from '../../actions'

import { putLoanApplicationUser } from '../../requesters/loanApplicationUser'
import {
  getLoanApplicationId,
   } from '../../reducers'

function* loanUpdateReview({type, payload}) {
  const loanApplicationId = yield select(getLoanApplicationId);

  let data = {
    loan_application_user: {
      terms_and_conditions: true
    }
  }

  const { response, error } = yield call(putLoanApplicationUser, loanApplicationId, data)

  if (response) {
    yield put(updateReviewSuccess(response))
  } else {
    const reviewData = error.response && error.response.data && error.response.data.review
    yield put(updateReviewFailure({
      entities: reviewData || {},
      result: reviewData ? Object.keys(reviewData) : [],
    }))
  }
}

export function* watchLoanUpdateReview() {
  yield takeLatest(UPDATE_REVIEW_START, loanUpdateReview)
}
